export default __webpack_public_path__ + "static/media/Slide1.5e943c11.jpg";